import apiClient from "./axiosConfig";

export const getAllTransactionItemHistory = async (request) =>
    apiClient.feesAPI.post(`/api/getAllTransactionItemHistory`, request);

export const getTransactionItemAdjustments = async (request) =>
    apiClient.feesAPI.post(`/api/getAllTransactionItemAdjustment`, request);

export const getTransactionReport = async (request) =>
    apiClient.feesAPI.post(`/api/transactionReportWithZCodes`, request);

export const getRegistrationAuditReport = async (request) =>
    apiClient.feesAPI.post(`/api/registration/getRegChangeLog`, request);
